/**
 * 労働者別の住民税額（特別徴収）。自治体が発行する特別徴収税額決定通知書が唯一の正であり、
 * DRESS CODE は外部取込でしか値を持たないため、本テーブルはサンプル値（架空の従業員）。
 */

import type { StatutoryStandardTable } from '../../types';

/**
 * 労働者別 住民税額（特別徴収税額通知）サンプル。個人 × 年度をキーに月次控除額を引く。
 * 100 円未満の端数は 6 月分に合算するため「7 月〜翌 5 月分」は 12 等分の下 2 桁を切り捨てた額、
 * 「6 月分」はその差額を吸収した額になっている（全行で `6月分 + 7月〜翌5月分 × 11 = 年税額` が成立）。
 */
export const residentTaxPerWorkerTable: StatutoryStandardTable = {
  columns: [{
    label: '社員番号'
  }, {
    label: '氏名'
  }, {
    label: '年度'
  }, {
    label: '市区町村'
  }, {
    align: 'end',
    label: '年税額（円）'
  }, {
    align: 'end',
    label: '6 月分（円）'
  }, {
    align: 'end',
    label: '7 月〜翌 5 月分（円）'
  }],
  rows: [['EMP-1001', '田村 拓真', '令和8年度', '東京都渋谷区', '187,200', '15,600', '15,600'], ['EMP-1002', '岡部 美咲', '令和8年度', '東京都渋谷区', '96,500', '8,500', '8,000'], ['EMP-1003', '川島 隆之', '令和8年度', '大阪市', '254,900', '21,700', '21,200'], ['EMP-1004', '大久保 稔', '令和8年度', '大阪市', '61,000', '6,000', '5,000'], ['EMP-1005', '藤原 里美', '令和8年度', '横浜市', '312,400', '26,400', '26,000'], ['EMP-1006', '小柳 亮介', '令和8年度', '名古屋市', '143,700', '12,800', '11,900'], ['EMP-1007', '中原 千夏', '令和8年度', '福岡県福岡市', '88,800', '7,400', '7,400'], ['EMP-1008', '望月 康平', '令和8年度', '札幌市', '201,300', '17,600', '16,700'], ['EMP-1009', '石垣 芽衣', '令和8年度', '埼玉県さいたま市', '55,600', '5,000', '4,600'], ['EMP-1010', '篠原 正和', '令和8年度', '神奈川県川崎市', '129,900', '11,100', '10,800']]
};